<template>
  <div class="tabs">
    <ul>
      <li class="tabs_active">{{ title }}</li>
    </ul>
    <div class="tabs_button">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "pageTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pageTitle/index.vue